import { useState, useEffect, useRef } from 'react'
import { useLocation, Link, useNavigate } from 'react-router-dom'
// ------ Services ------ //
import * as badgeService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'
import styles from './KioskScannerPageSetup.module.css'
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'
const KioskScannerPageSetup = ({ user }) => {
    const location = useLocation()
    const passedState = location.state
    const navigate = useNavigate()
    const [formData, setFormData] = useState([
        {
            id: null,
            pageTitle: '',
            scanMessage: 'Please scan the barcode from your registration receipt email.',
            searchLabel: 'Don\'t have your receipt email? Search By Last Name',
            printBadge: null,
            active: null
        }
    ])

    const [message, setMessage] = useState([''])
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(false)
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])
    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }
        return await requestBody;
    }

    /* -------- Functions -------- */

    const fetchScannerPageSetup = async () => {
        const getReqBody = await createRequestBody()
        const data = await badgeService.getScannerPageSetup(getReqBody)
        if (data) {
            setFormData(data)
        }

    }

    // useEffect - placeholder fetch function until controller & backend func is created
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.eventId) {
            fetchScannerPageSetup()
        }

    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    const handleContinueButtonVisiblity = () => {
        formData.pageTitle !== undefined  &&
            formData.pageTitle.length
            && formData.scanMessage !== undefined
            && formData.scanMessage.length
            && formData.searchLabel !== undefined
            && formData.searchLabel.length
            ? setContinueButtonVisibility(true)
            : setContinueButtonVisibility(false)
    }

    useEffect(() => {
        if (formData && formData.pageTitle && formData.scanMessage && formData.searchLabel) {
            handleContinueButtonVisiblity()
        }
    }, [formData.pageTitle, formData.scanMessage, formData.searchLabel])
    const createSaveRequest = (items) => {
        const fieldsSave = { ...formData, 'ClientId': clientEventInfo.clientId, 'EventId': clientEventInfo.eventId }
        return fieldsSave
    }

    const handleSave = async e => {
        if (e) {
            e.preventDefault()
        }
        let saverequest = createSaveRequest();
        try {
            await badgeService.saveScannerPageSetup(saverequest)
        } catch (err) {
            setMessage(err.message)
        }

    }
    const handleSaveAndNavigate = async e => {
        e.preventDefault()
        try {
            await handleSave()
            navigate('/KioskManager', { state: clientEventInfo })
        } catch (err) {
            setMessage(err.message)
        }

    }
    return (
        <div className="page-area">
            <div className={styles.templateIndex}>
                <h1>Event Kiosk Scanner Page Setup</h1>
                <br /> <br />
                <BackSaveContinueButton
                    continueButtonVisibility={continueButtonVisibility}
                    handleSaveAndNavigate={handleSaveAndNavigate}
                    handleSave={handleSave}
                    styles={styles}
                    navigate={navigate}
                />
                {
                    message ?
                        <h2>{message}</h2> :
                        <></>
                }
                <br />
                <h3>
                    <div className={styles.wrapper}>
                        Page Title - Name shown at top of scanner page screen (typically event name). <br />
                        Scan Message - Instructions for scanning process. 'Please scan the barcode from your registration receipt email.'<br />
                        Search Label - Search label guide - 'Don't have your receipt email? Search By Last Name'. <br />
                        Print Badge - True - Skip edit badge step.<br />
                        Active - True - Enables navigation. <br />
                    </div>
                </h3>
                <div>
                   
                    <div className={styles.inputContainer}>
                        <label title="Name shown at top of scanner page screen (typically event name).">
                            Page Title: <input
                                className={styles.scanPageInput}
                                type="text"
                                value={formData.pageTitle}
                                name="pageTitle"
                                onChange={handleChange}
                            />

                        </label>
                    </div>
                    <div className={styles.inputContainer}>
                        <label title="Instructions for scanning process. 'Please scan the barcode from your registration receipt email.'">
                            Scan Message: <input
                                className={styles.scanPageInput}
                                type="text"
                                value={formData.scanMessage}
                                name="scanMessage"
                                onChange={handleChange}
                            />

                        </label>
                    </div>
                    <div className={styles.inputContainer}>
                        <label title="Search label guide - 'Don't have your receipt email? Search By Last Name'.">
                            Search Label: <input
                                className={styles.scanPageInput}
                                type="text"
                                value={formData.searchLabel}
                                name="searchLabel"
                                onChange={handleChange}
                            />

                        </label>
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.left}>
                            <div className={styles.inputContainer}>
                                <label className={styles.label} title="True - skip edit badge step.">
                                    Print Badge: <input
                                        type="checkbox"
                                        autoComplete="off"
                                        checked={formData.printBadge ? true : false}
                                        name="printBadge"
                                        onChange={handleChange}
                                        style={{
                                            width: '10%',
                                        }}
                                    />

                                </label>

                            </div>
                        </div>
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.left}>
                            <div className={styles.inputContainer}>
                                <label className={styles.label} title="True - used in navigation.">
                                    Active: <input
                                        type="checkbox"
                                        autoComplete="off"
                                        checked={formData.active ? true : false}
                                        name="active"
                                        onChange={handleChange}
                                        style={{
                                            width: '10%',
                                        }}
                                    />

                                </label>

                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <br /> <br />
                    <BackSaveContinueButton
                        continueButtonVisibility={continueButtonVisibility}
                        handleSaveAndNavigate={handleSaveAndNavigate}
                        handleSave={handleSave}
                        styles={styles}
                        navigate={navigate}
                    />
                    <br />
                </div>

            </div>
        </div>
    );
}

export default KioskScannerPageSetup;